
<b-modal
  v-model="localShow"
  @hidden="handleHidden"
  id="cookie-consent-modal"
  :no-close-on-backdrop="true"
  :no-close-on-esc="true"
  centered
  headerClass="p-2 border-bottom-0"
  auto-focus-button="ok"
  no-stacking
  content-class="custom-modal"
>
  <template v-slot:modal-header>
    <div class="mb-n3">
      <img
        :src="mmsLogoBlack"
        alt="MMS"
        class="logo"
      />
      <p class="header-title">{{ appName }} uses cookies</p>
    </div>
  </template>
  <div class="bread-text">
    <p>
      By continuing to use this website, you accept our privacy policy and consent to our use of cookies to ensure functionality and user experience.
    </p>

    <div class="link-list">
      <a
        href="https://mms.se/cookies/"
        target="_blank"
        rel="noopener noreferrer"
        >Read more about cookies</a
      >
      <a
        href="https://mms.se/om-oss/integritetspolicy/"
        target="_blank"
        rel="noopener noreferrer"
        >Read more about MMS privacy policy</a
      >
    </div>
  </div>
  <template v-slot:modal-footer>
    <div class="footer-container">
      <b-button
        variant="primary"
        @click="consentToCookies()"
        class="consent-button"
        >Accept</b-button
      >
    </div>
  </template>
</b-modal>
